import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AsVo } from "src/vo/asVo";
import { EstimateGoods, EstimateListVo, EstimateVo } from "src/vo/estimateVo";
import { UserVo } from "src/vo/userVo";

const initialState: EstimateVo = {
  estimate_goods: JSON,
  estimate_goods_update: {},
  estimate_goods_list: [],
};

const estimateSlice = createSlice({
  name: "estimate",
  initialState,
  reducers: {
    initSheet: (state) => {
      state.estimate_goods_list = [];
      // state.estimate_goods_update = action.payload;
    },
    setAPISheetAdd: (state, action: PayloadAction<Array<EstimateGoods>>) => {
      state.estimate_goods_list = action.payload;
      // state.estimate_goods_update = action.payload;
    },
    setAddSheet: (state, action: PayloadAction<EstimateGoods>) => {
      state.estimate_goods_list?.push(action.payload);
      // state.estimate_goods_update = action.payload;
    },
    setValueChange: (state, action: PayloadAction<EstimateGoods>) => {
      //   state.estimate_goods_list?.push(action.payload);
      state.estimate_goods = action.payload;
    },
    deleteGoodsReduce: (state, action: PayloadAction<number>) => {
      state.estimate_goods_list?.splice(action.payload, 1);
    },
    goodsClickReduce: (state, action: PayloadAction<EstimateGoods>) => {
      state.estimate_goods_update = action.payload;
    },
  },
});

// 3-1. export actions
export const { initSheet, setAPISheetAdd, setAddSheet, setValueChange, deleteGoodsReduce, goodsClickReduce } = estimateSlice.actions;
// 3-2. export default slice.reducer
export default estimateSlice.reducer;
